<template>
  <div class="login-personalize-preview-panel-section">
    <p v-if="title"
       class="login-personalize-preview-panel-section-title">{{ title }}</p>

    <slot />
  </div>
</template>

<script>
export default {
  components: {},

  data() {
    return {};
  },

  props: {
    title: {
      type: String,
    },
  },

  computed: {},

  methods: {},

  mounted() {},

  beforeDestroy() {},
};
</script>

<style lang="scss" scoped>
@import "~@variables";

.login-personalize-preview-panel-section {
  padding: 15px 10px;
  border-bottom: 2px solid $grey-1;

  .login-personalize-preview-panel-section-title {
    font-size: 14px;
    color: #4d4f5c;
    font-weight: 600;
    margin: 0 0 10px 0;
  }
}
</style>
